import React from 'react';
import { Button } from 'antd';

const SubmitButton = ({ type_, disabled_, onClick_, loading_, children, className_, htmlType_ }) => {
  return (
    <Button
      type={type_}
      htmlType={htmlType_}
      disabled={disabled_}
      loading={loading_}
      onClick={onClick_}
      // block
      className={className_}
    >
      {children}
    </Button>
  );
};

export default SubmitButton;
